<template>
  <div class="filtrate">
    <el-dialog title="条件筛选(可多选)" :visible.sync="filtrateVisible" width="90%" :show-close="true">
      <div class="content">
        <el-scrollbar style="height: 100%;">
          <ul>
            <li>
              <div class="flex align-center">
                <div class="label">客户类型</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.customerType" :key="index" class="option-item mr-10" :class="{'active-item': customerType.indexOf(item.text) !== -1}" @click="selectItem(item.text, 1)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="flex align-center">
                <div class="label">客户来源</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.customerSource" :key="index" class="option-item mr-10" :class="{'active-item': customerSource.indexOf(item.text) !== -1}" @click="selectItem(item.text, 2)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="flex align-center">
                <div class="label">客户级别</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.priority" :key="index" class="option-item mr-10" :class="{'active-item': priority.indexOf(item.text) !== -1}" @click="selectItem(item.text, 3)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="flex align-center">
                <div class="label">房屋类型</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.houseType" :key="index" class="option-item mr-10" :class="{'active-item': houseType.indexOf(item.text) !== -1}" @click="selectItem(item.text, 4)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="flex align-center">
                <div class="label">户<span style="display: inline-block; width: 2em;"></span>型</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.homeType" :key="index" class="option-item mr-10" :class="{'active-item': homeType.indexOf(item.text) !== -1}" @click="selectItem(item.text, 5)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="flex align-center">
                <div class="label">所在方位</div>
                <div class="flex">
                  <div v-for="(item, index) in filterList.location" :key="index" class="option-item mr-10" :class="{'active-item': location.indexOf(item.text) !== -1}" @click="selectItem(item.text, 6)">{{item.text}}</div>
                </div>
              </div>
            </li>
            <li class="border-0">
              <div class="flex align-center">
                <div class="label">楼盘小区</div>
                <div class="flex align-center" style="width:400px;">
                  <el-input v-model="residentialDistrict"></el-input>
                </div>
              </div>
            </li>
            <li class="border-0">
              <div class="flex align-center">
                <div class="label">建筑面积</div>
                <div class="flex align-center input">
                  <el-input v-model="startArea">
                    <i slot="suffix" class="el-input__icon">㎡</i>
                  </el-input>
                  <span class="mlr-10 font-12-b9b9b9">-</span>
                  <el-input v-model="endArea">
                    <i slot="suffix" class="el-input__icon">㎡</i>
                  </el-input>
                </div>
              </div>
            </li>
            <li class="bg-f3f4f7">
              <div class="flex align-center">
                <div class="label">部<span style="display: inline-block; width: 2em;"></span>门</div>
                <div class="flex flex-1">
                  <div class="flex w-100" v-for="(item, index) in department" :key="index">
                    <div class="flex-1">
                      <OptionCheck :title="item.title" :index="index" ref="department" :isDepartment="true"></OptionCheck>
                      <div class="flex align-center flex-wrap">
                        <el-tag class="mt-5" v-for="(tag, i) in item.selected1" :key="i" closable @close="departmentClose(tag, index)">{{tag}}</el-tag>
                      </div>
                    </div>
                    <div class="line-dashed" v-if="index < department.length - 1"></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="bg-f3f4f7 border-0">
              <div class="flex align-center">
                <div class="label">员<span style="display: inline-block; width: 2em;"></span>工</div>
                <div class="flex flex-1">
                  <div class="flex w-100" v-for="(item, index) in employee" :key="index">
                    <div class="flex-1">
                      <OptionCheck :title="item.title" :index="index" :currentProcessKey="currentProcessKey" ref="employee" :isDepartment="false"></OptionCheck>
                      <div class="flex align-center flex-wrap">
                        <el-tag class="mt-5" v-for="(tag, i) in item.selected1" :key="i" closable @close="employeeClose(tag, index)">{{tag}}</el-tag>
                      </div>
                    </div>
                    <div class="line-dashed" v-if="index < employee.length - 1"></div>
                  </div>
                </div>
              </div>
            </li>
            <li class="border-0 flex align-center">
              <div class="flex align-center mr-20">
                <div class="label">预算金额</div>
                <div class="flex align-center input">
                  <el-input v-model="startPre">
                    <i slot="suffix" class="el-input__icon">元</i>
                  </el-input>
                  <span class="mlr-10 font-12-b9b9b9">-</span>
                  <el-input v-model="endPre">
                    <i slot="suffix" class="el-input__icon">元</i>
                  </el-input>
                </div>
              </div>
              <div class="flex align-center">
                <div class="label">结算金额</div>
                <div class="flex align-center input">
                  <el-input v-model="startSettlement">
                    <i slot="suffix" class="el-input__icon">元</i>
                  </el-input>
                  <span class="mlr-10 font-12-b9b9b9">-</span>
                  <el-input v-model="endSettlement">
                    <i slot="suffix" class="el-input__icon">元</i>
                  </el-input>
                </div>
              </div>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <div slot="footer">
        <div class="btn-30-border-46b8b0-s mr-10" @click="onReset">重置</div>
        <div class="btn-30-bg-46b8b0-s" @click="onSubmit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OptionCheck from './FiltrateOption'
export default {
  name: 'Filtrate',
  components: {OptionCheck},
  props: ['filterList', 'currentProcessKey'],
  // ,
  data () {
    return {
      filtrateVisible: false,
      startArea: null,
      residentialDistrict: '',
      endArea: null,
      startPre: null,
      endPre: null,
      startSettlement: null,
      endSettlement: null,
      department: [{
        title: '业务部',
        selected: [],
        selected1: []
      }, {
        title: '设计部',
        selected: [],
        selected1: []
      }, {
        title: '客服部',
        selected: [],
        selected1: []
      }, {
        title: '核算部',
        selected: [],
        selected1: []
      }, {
        title: '项目经理部',
        selected: [],
        selected1: []
      }, {
        title: '工程部',
        selected: [],
        selected1: []
      }],
      employee: [{
        title: '业务员',
        selected: [],
        selected1: []
      }, {
        title: '设计师',
        selected: [],
        selected1: []
      }, {
        title: '客户经理',
        selected: [],
        selected1: []
      }, {
        title: '核算员',
        selected: [],
        selected1: []
      }, {
        title: '项目经理',
        selected: [],
        selected1: []
      }, {
        title: '工程监理',
        selected: [],
        selected1: []
      }],
      customerType: [], // 已选客户类型
      customerSource: [], // 已选客户来源
      priority: [], // 已选客户级别
      houseType: [], // 已选房屋类型
      homeType: [], // 已选户型
      location: [], // 已选方位
      filterStr: [] // 最终筛选条件
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    selectItem (item, i) {
      switch (i) {
        case 1:
          if (this.customerType.indexOf(item) === -1) {
            this.customerType.push(item)
          } else {
            this.customerType.splice(this.customerType.indexOf(item), 1)
          }
          break
        case 2:
          if (this.customerSource.indexOf(item) === -1) {
            this.customerSource.push(item)
          } else {
            this.customerSource.splice(this.customerSource.indexOf(item), 1)
          }
          break
        case 3:
          if (this.priority.indexOf(item) === -1) {
            this.priority.push(item)
          } else {
            this.priority.splice(this.priority.indexOf(item), 1)
          }
          break
        case 4:
          if (this.houseType.indexOf(item) === -1) {
            this.houseType.push(item)
          } else {
            this.houseType.splice(this.houseType.indexOf(item), 1)
          }
          break
        case 5:
          if (this.homeType.indexOf(item) === -1) {
            this.homeType.push(item)
          } else {
            this.homeType.splice(this.homeType.indexOf(item), 1)
          }
          break
        case 6:
          if (this.location.indexOf(item) === -1) {
            this.location.push(item)
          } else {
            this.location.splice(this.location.indexOf(item), 1)
          }
          break
      }
    },
    departmentClose (item, index) {
      this.$refs.department[index].selectedList.splice(this.$refs.department[index].selectedList.indexOf(item), 1)
      this.department[index].selected.splice(this.department[index].selected.indexOf(item), 1)
      this.department[index].selected1.splice(this.department[index].selected1.indexOf(item), 1)
    },
    employeeClose (item, index) {
      this.$refs.employee[index].selectedList.splice(this.$refs.employee[index].selectedList.indexOf(item), 1)
      this.employee[index].selected.splice(this.employee[index].selected.indexOf(item), 1)
      this.employee[index].selected1.splice(this.employee[index].selected1.indexOf(item), 1)
    },
    onReset () {
      this.customerType = []
      this.customerSource = []
      this.priority = []
      this.houseType = []
      this.homeType = []
      this.location = []
      this.list = []
      this.filterStr = []
      this.startArea = null
      this.residentialDistrict = ''
      this.endArea = null
      this.startPre = null
      this.endPre = null
      this.startSettlement = null
      this.endSettlement = null
      this.department = [{
        title: '业务部',
        selected: [],
        selected1: []
      }, {
        title: '设计部',
        selected: [],
        selected1: []
      }, {
        title: '客服部',
        selected: [],
        selected1: []
      }, {
        title: '核算部',
        selected: [],
        selected1: []
      }, {
        title: '项目经理部',
        selected: [],
        selected1: []
      }, {
        title: '工程部',
        selected: [],
        selected1: []
      }]
      this.employee = [{
        title: '业务员',
        selected: [],
        selected1: []
      }, {
        title: '设计师',
        selected: [],
        selected1: []
      }, {
        title: '客户经理',
        selected: [],
        selected1: []
      }, {
        title: '核算员',
        selected: [],
        selected1: []
      }, {
        title: '项目经理',
        selected: [],
        selected1: []
      }, {
        title: '工程监理',
        selected: [],
        selected1: []
      }]
      if (this.$refs.department) {
        this.$refs.department.forEach(i => {
          i.selectedList = []
          i.selectedId = []
        })
      }
      if (this.$refs.employee) {
        this.$refs.employee.forEach(i => {
          i.selectedList = []
          i.selectedId = []
        })
      }
    },
    onSubmit () {
      this.filterStr = [{
        key: 'customerType',
        field: 'customer_type',
        type: 'string',
        list: this.customerType
      }, {
        key: 'customerSource',
        field: 'customer_source',
        type: 'string',
        list: this.customerSource
      }, {
        key: 'priority',
        field: 'priority',
        type: 'string',
        list: this.priority
      }, {
        key: 'houseType',
        field: 'house_type',
        type: 'string',
        list: this.houseType
      }, {
        key: 'homeType',
        field: 'home_type',
        type: 'string',
        list: this.homeType
      }, {
        key: 'location',
        field: 'location',
        type: 'string',
        list: this.location
      }, {
        key: 'buildingArea',
        field: 'building_area',
        type: 'range',
        valueStart: this.startArea,
        valueEnd: this.endArea
      }, {
        key: 'budgetAmount',
        field: 'budget_amount',
        type: 'range',
        valueStart: this.startPre,
        valueEnd: this.endPre
      }, {
        key: 'settlementAmount',
        field: 'settlement_amount',
        type: 'range',
        valueStart: this.startSettlement,
        valueEnd: this.endSettlement
      }, {
        key: 'submitSalesman',
        type: 'department',
        list: this.department[0].selected,
        list1: this.department[0].selected1
      }, {
        key: 'submitDesigner',
        type: 'department',
        list: this.department[1].selected,
        list1: this.department[1].selected1
      }, {
        key: 'submitCm',
        type: 'department',
        list: this.department[2].selected,
        list1: this.department[2].selected1
      }, {
        key: 'submitBe',
        type: 'department',
        list: this.department[3].selected,
        list1: this.department[3].selected1
      }, {
        key: 'submitPm',
        type: 'department',
        list: this.department[4].selected,
        list1: this.department[4].selected1
      }, {
        key: 'submitSu',
        type: 'department',
        list: this.department[5].selected,
        list1: this.department[5].selected1
      }, {
        key: 'submitSalesman',
        type: 'employee',
        list: this.employee[0].selected,
        list1: this.employee[0].selected1
      }, {
        key: 'submitDesigner',
        type: 'employee',
        list: this.employee[1].selected,
        list1: this.employee[1].selected1
      }, {
        key: 'submitCm',
        type: 'employee',
        list: this.employee[2].selected,
        list1: this.employee[2].selected1
      }, {
        key: 'submitBe',
        type: 'employee',
        list: this.employee[3].selected,
        list1: this.employee[3].selected1
      }, {
        key: 'submitPm',
        type: 'employee',
        list: this.employee[4].selected,
        list1: this.employee[4].selected1
      }, {
        key: 'submitSu',
        type: 'employee',
        list: this.employee[5].selected,
        list1: this.employee[5].selected1
      }, {
        key: 'residentialDistrict',
        field: 'residential_district',
        type: 'string',
        list: [this.residentialDistrict]
      }]
      this.$parent.filterStr = this.filterStr
      this.filtrateVisible = false
      this.$parent.filterData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .close{
    color: #30313a;
    font-size: 22px;
    font-weight: bold;
    position: absolute;
    top:10px;
    right: 10px;
  }
  ul, li{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  .content{
    height: 520px;
    overflow-y: auto;
  }
  .content /deep/ .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .content li {
    padding:8px 20px 0;
  }
  .content li > div{
    border-bottom: 1px dashed #e2e2e2;
    padding-bottom: 8px;
  }
  .content .label{
    font-size: 16px;
    color: #30313a;
    font-weight: bold;
    text-align: left;
    margin-right: 10px;
  }
  .input /deep/ .el-input__suffix {
    right: 8px;
  }
  .input /deep/ .el-input__inner{
    height: 30px;
    line-height: 30px;
    width: 100px;
  }
  .input /deep/ .el-input{
    font-size: 12px;
  }
  .input /deep/ .el-input__icon{
    line-height: 30px;
    color: #30313a;
    font-style: normal;
  }
  .bg-f3f4f7{
    background: #f3f4f7;
  }
  .content .border-0 > div{
    border-bottom: none;
  }
  .line-dashed{
    width: 1px;
    height: 100%;
    border-right: 1px dashed #e2e2e2;
    margin: 0 8px;
  }
  .el-tag{
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #46b8b0;
    border-color: #46b8b0;
    background: #fef0dd;
    padding: 0 10px;
  }
  .el-tag /deep/ .el-tag__close{
    color: #46b8b0;
  }
  .el-tag /deep/ .el-tag__close:hover{
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/Filtrate.vue